import _implicitStylesheets from "./panelHeader.css";

import _implicitScopedStylesheets from "./panelHeader.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, t: api_text, h: api_element, b: api_bind, k: api_key, i: api_iterator} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("div", {
    classMap: {
      "slds-page-header": true,
      "panel-header_align": true
    },
    attrs: {
      "data-my-id": "panelHeaderDiv"
    },
    key: 0
  }, [api_element("div", {
    classMap: {
      "slds-page-header__row": true,
      "header_row_align": true
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "slds-page-header__col-title": true
    },
    key: 2
  }, [api_element("div", {
    classMap: {
      "slds-media": true
    },
    key: 3
  }, [api_element("div", {
    classMap: {
      "slds-media__body": true
    },
    key: 4
  }, [api_element("div", {
    classMap: {
      "slds-page-header__name": true
    },
    key: 5
  }, [api_element("div", {
    classMap: {
      "slds-page-header__name-title": true
    },
    key: 6
  }, [api_element("span", {
    attrs: {
      "data-my-id": "panelTitle"
    },
    key: 7
  }, [api_text(api_dynamic_text($cmp.title))])])])])])]), api_element("div", {
    classMap: {
      "slds-page-header__col-actions": true,
      "button-position_align": true
    },
    attrs: {
      "data-my-id": "menuOptionsDiv"
    },
    key: 8
  }, [api_element("div", {
    classMap: {
      "slds-page-header__controls": true
    },
    key: 9
  }, [api_element("div", {
    classMap: {
      "slds-page-header__control": true
    },
    key: 10
  }, [api_element("a", {
    classMap: {
      "button-bg_align": true
    },
    attrs: {
      "data-my-id": "panelMenuTitle"
    },
    key: 11,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.showOptions)),
      "blur": _m1 || ($ctx._m1 = api_bind($cmp.hideOptions))
    }
  }, [api_text(api_dynamic_text($cmp.menuTitle))]), api_element("div", {
    classMap: {
      "slds-dropdown-trigger": true,
      "slds-dropdown-trigger_click": true
    },
    key: 12
  }, [api_element("div", {
    classMap: {
      "slds-dropdown": true,
      "slds-dropdown_right": true,
      "menu-pos_align": true
    },
    key: 13,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleMenuSelect))
    }
  }, [api_element("ul", {
    classMap: {
      "slds-dropdown__list": true
    },
    attrs: {
      "role": "menu"
    },
    key: 14
  }, api_iterator($cmp.menuOptions, function (menuOption) {
    return api_element("li", {
      classMap: {
        "slds-dropdown__item": true
      },
      attrs: {
        "role": "role"
      },
      key: api_key(15, menuOption.value)
    }, [api_element("a", {
      attrs: {
        "href": "#",
        "role": "menuitem",
        "tabindex": "0"
      },
      key: 16
    }, [api_element("span", {
      classMap: {
        "slds-truncate": true
      },
      attrs: {
        "title": menuOption.value,
        "data-my-id": "optionItem"
      },
      key: 17
    }, [api_text(api_dynamic_text(menuOption.label))])])]);
  }))])])])])])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-panelHeader_panelHeader"
